/* eslint-disable @typescript-eslint/camelcase */
//TODO: Add test cases for the affected APIS for this change [DDMP-13379]
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import config from 'jss-boilerplate/temp/config.js';
import { getCurrentUrlHostname } from 'core/utils/global-utils';
import {
	AKAMAI_BOT_FLAG,
	SITECORE_AUTHORIZATION,
	X_CORRELATION_APP,
} from 'core/constants';
import {
	ILoginPasswordRequestData,
	IMobileAuthRequestData,
	IMobileAuthPushInitiateRequestData,
	IMobileAuthPushDeviceCheckRequestData,
	IMobileAuthPushPollingWaitData,
	IMobileAuthLoginPushRequestData,
} from 'jss-components/t07-account-access/Login/Login.types';

const isDevelopmentEnv = process.env.NODE_ENV === 'development';

/**
 * Call Sitecore API for Member Login
 * @param {any} data Username and Password
 */
export function memberLogin(data: any) {
	// TODO - define types

	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberLogin}`;

	return axios({
		url,
		method: 'POST',
		data,
		// note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
		// which is necessary for analytics and such, same with lines 69 and 84
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 * MAU Journey 2: Login Pwd Auth for Token ID
 * Second call for password login
 * @param {ILoginPasswordRequestData} data Username, Password, initial, usernamenew
 * @param {string} authContextId context ID randomly generated for each session
 */
export function memberLoginClassic(
	data: ILoginPasswordRequestData,
	authContextId?: string,
) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberLoginClassic}`;

	return axios({
		url,
		method: 'POST',
		data,
		headers: {
			'X-Correlation-Id': uuidv4(), // FED initiated correlation ID
			'X-Auth-Context-Id': authContextId, // Fed initiated auth context ID
			'X-Correlation-App': X_CORRELATION_APP, // @note Security logging Header as per DDMP-13655
		},
		// note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
		// which is necessary for analytics and such, same with lines 69 and 84
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 *
 * @param data Username, device details: containing uuid(), window.navigator, lat/lng
 */
export function memberDeviceLogin(data: IMobileAuthRequestData) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberDeviceLogin}`;

	return axios({
		url,
		method: 'POST',
		data,
		// note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
		// which is necessary for analytics and such, same with lines 69 and 84
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 *
 * @param data Username
 *
 * 1st MAU push call, account existence check
 *
 * TODO: Remove once member login push is confirmed to be used permanently
 * Also check azure-pipelines.yaml
 *
 */
export function memberPushInitiate(data: IMobileAuthPushInitiateRequestData) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberPushInitiate}`;

	return axios({
		url,
		method: 'POST',
		data,
		// note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
		// which is necessary for analytics and such, same with lines 69 and 84
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 *
 * @param data
 *
 * 2nd MAU push call, account locked check
 *
 * TODO: Remove once member login push is confirmed to be used permanently
 * Also check azure-pipelines.yaml
 *
 */
export function memberPushAccountCheck(data: {}) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberPushAccountCheck}`;

	return axios({
		url,
		method: 'POST',
		data,
		// note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
		// which is necessary for analytics and such, same with lines 69 and 84
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 *
 * @param data
 *
 * 3rd MAU push call, check if device is registered
 *
 * TODO: Remove once member login push is confirmed to be used permanently
 * Also check azure-pipelines.yaml
 *
 */
export function memberPushDeviceCheck(
	data: IMobileAuthPushDeviceCheckRequestData,
) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberPushDeviceCheck}`;

	return axios({
		url,
		method: 'POST',
		data,
		// note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
		// which is necessary for analytics and such, same with lines 69 and 84
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 *
 * @param data
 * @param {string} authContextId context ID randomly generated for each session
 *
 * Consolidated MAU push and check calls:
 * - check if device is registered
 * - check if account is existing
 * - send push notification
 *
 * TODO: Consider adding unit tests for this
 *
 */
export function memberLoginPush(
	data: IMobileAuthLoginPushRequestData,
	authContextId?: string,
) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberLoginPush}`;

	return axios({
		url,
		method: 'POST',
		data,
		headers: {
			'X-Correlation-Id': uuidv4(), // FED initiated correlation ID
			'X-Auth-Context-Id': authContextId, // Fed initiated auth context ID
			'X-Correlation-App': X_CORRELATION_APP, // @note Security logging Header as per DDMP-13655
		},
		// note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
		// which is necessary for analytics and such, same with lines 69 and 84
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 *
 * @param data IMobileAuthPushPollingWaitData
 * @param {string} authContextId context ID randomly generated for each session
 *
 * Actual polling wait call. Loops according to set total duration and intervals
 * Will be waiting for either accept/deny/expired responses
 */
export function memberPushPollingWait(
	data: IMobileAuthPushPollingWaitData,
	authContextId?: string,
) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberPushPollingWait}`;

	return axios({
		url,
		method: 'POST',
		data,
		headers: {
			'X-Correlation-Id': uuidv4(), // FED initiated correlation ID
			'X-Auth-Context-Id': authContextId, // Fed initiated auth context ID
			'X-Correlation-App': X_CORRELATION_APP, // @note Security logging Header as per DDMP-13655
		},
		// note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
		// which is necessary for analytics and such, same with lines 69 and 84
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 *
 * @param data
 * @param {string} authContextId context ID randomly generated for each session
 *
 * Absolutely redundant endpoint for resending or canceling while within
 * expired/denied page
 */
export function memberPushResend(
	data: IMobileAuthPushDeviceCheckRequestData,
	authContextId?: string,
) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberPushResend}`;

	return axios({
		url,
		method: 'POST',
		data,
		headers: {
			'X-Correlation-Id': uuidv4(), // FED initiated correlation ID
			'X-Auth-Context-Id': authContextId, // Fed initiated auth context ID
			'X-Correlation-App': X_CORRELATION_APP, // @note Security logging Header as per DDMP-13655
		},
		// note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
		// which is necessary for analytics and such, same with lines 69 and 84
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 * Call CAT Authorise API for Member Login
 * @param {string} authContextId context ID randomly generated for each session
 */
export function memberAuthorize(
	ssoTokenId: string,
	redirectUrl: string,
	authContextId?: string,
) {
	const base = `${config.australianSuperApi?.apiDomain}${config.australianSuperApi?.apiPathIdentity}`;

	const url = `${base}/sitecore-authorize`;

	return axios({
		url,
		method: 'POST',
		headers: {
			'X-API-Key': config?.externalServices?.coarseGrainApiKey, // API Coarse grain
			'X-Correlation-Id': uuidv4(), // FED initiated correlationID
			'X-Auth-Context-Id': authContextId, // Fed initiated auth context ID
			'X-Correlation-App': X_CORRELATION_APP, // Link detection of request origin
		},
		withCredentials: AKAMAI_BOT_FLAG, // akamai bot detection
		data: {
			data: {
				sso_token: ssoTokenId,
				redirect_uri: redirectUrl,
				client_id: SITECORE_AUTHORIZATION.CLIENT_ID,
				decision: SITECORE_AUTHORIZATION.DECISION,
				response_type: SITECORE_AUTHORIZATION.RESPONSE_TYPE,
				scope: SITECORE_AUTHORIZATION.SCOPE,
			},
		},
	});
}

/**
 * Call Sitecore API for Member Logout
 * @param {authContextId} auth context ID randomly generated for each session
 */
export function memberLogout(authContextId?: string) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberLogout}`;

	return axios({
		url,
		method: 'POST',
		headers: {
			'X-Correlation-Id': uuidv4(), // FED initiated correlationID
			'X-Auth-Context-Id': authContextId, // Fed initiated auth context ID
			'X-Correlation-App': X_CORRELATION_APP, // @note Security logging Header as per DDMP-13655
		},
		data: {},
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 * Call Process Auth Code plus Browser Cookies
 * @param {data} response from the previous API
 * @param {domainName} host name from the current/active tab
 */
export function memberProcessAuthCode(
	data: any,
	domainName: string,
	authContextId?: string,
) {
	const baseUrl = `${data?.redirect_uri}?code=${data?.code}&iss=${data?.issuer}&client_id=${data?.client_id}&redirect_uri=${domainName}`;

	return axios({
		url: baseUrl,
		method: 'POST',
		headers: {
			'X-Correlation-Id': uuidv4(), // FED initiated correlation ID
			'X-Auth-Context-Id': authContextId, // Fed initiated auth context ID
			'X-Correlation-App': X_CORRELATION_APP, // @note Security logging Header as per DDMP-13655
		},
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 * Call Sitecore API for Member Refresh Token
 * @param {rtoken} old refresh token
 * @param {authContextId} auth context ID randomly generated for each session
 */
export function memberRefreshToken(rtoken: string, authContextId?: string) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberRefreshToken}`;

	return axios({
		url,
		method: 'POST',
		headers: {
			'X-Correlation-Id': uuidv4(), // FED initiated correlationID
			'X-Auth-Context-Id': authContextId, // Fed initiated auth context ID
		},
		data: {
			refresh_token: rtoken,
		},
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 * Pulls the annual investment performance data from the Sitecore API
 * @param {type} accumulation or pension
 * @param {classification} account_type=TTR or ''
 */
export function memberGetAnnualInvestmentPerformance(
	type: string,
	classification: string,
) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberAnnualInvestmentPerformance}/${type}${classification}`;

	return axios({
		url,
		method: 'GET',
		// MFA (Multi Factor Authentication) APIs
	});
}
/**
 * TODO: Create unit tests for this api
 * Validate OTP (One Time Password)
 * @param {string} otpCode
 * @param {string} authContextId
 */
export function memberLoginValidateOtp(
	otpCode: string,
	authContextId?: string,
) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberLoginValidateOtp}`;

	return axios({
		url,
		method: 'POST',
		data: {
			code: otpCode,
		},
		headers: {
			'X-Correlation-Id': uuidv4(), // FED initiated correlation ID
			'X-Auth-Context-Id': authContextId, // Fed initiated auth context ID
			'X-Correlation-App': X_CORRELATION_APP, // @note Security logging Header as per DDMP-13655
		},
		withCredentials: !isDevelopmentEnv,
	});
}

/**
 * TODO: Create unit tests for this api
 * Resend OTP (One Time Password) request
 * @param {string} authContextId
 */
export function memberLoginSendOtp(authContextId?: string) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberLoginSendOtp}`;

	return axios({
		url,
		method: 'POST',
		data: {},
		headers: {
			'X-Correlation-Id': uuidv4(), // FED initiated correlation ID
			'X-Auth-Context-Id': authContextId, // Fed initiated auth context ID
			'X-Correlation-App': X_CORRELATION_APP, // @note Security logging Header as per DDMP-13655
		},
		withCredentials: !isDevelopmentEnv,
	});
}

export function memberLoginTrustDevice(
	isTrustDevice: boolean,
	trustDeviceId?: string,
	authContextId?: string,
) {
	const url = `${getCurrentUrlHostname}${config.sitecoreApi.apiPathMemberLoginTrustDevice}`;

	return axios({
		url,
		method: 'POST',
		data: {
			TrustDevice: isTrustDevice ? 0 : 1,
			DeviceToReplace: trustDeviceId ? trustDeviceId : null,
		},
		headers: {
			'X-Correlation-Id': uuidv4(), // FED initiated correlation ID
			'X-Auth-Context-Id': authContextId, // Fed initiated auth context ID
			'X-Correlation-App': X_CORRELATION_APP, // @note Security logging Header as per DDMP-13655
		},
		withCredentials: !isDevelopmentEnv,
	});
}
